export const NAME = 'myWork';
export const REQUEST_REVIEW_ENTRY_IDENTIIFIER = `${NAME}/requestReviewEntry`;
export const REVIEW_ASSIGNED_EVENT = 'assigned';
